module.exports = __webpack_public_path__ + "img/prismnet.306fc3a9.png";